import {
	Box,
	Typography,
	Spacer,
	InputSelect,
	InputField,
	Button,
} from '@bcp-nextgen-dx-component-factory/design-system';
import { rem } from '@helpers';

import { useRequestToCallOpenHelper } from './requestToCallOpen.helper';

interface RequestToCallOpenProp {
	phone: string;
	indicative: string;
	validateClickToCallAgentOpen: () => void;
	setIndicative: (indicative: string) => void;
	setPhone: (phone: string) => void;
	setContactToCallCountry: (country: string) => void;
}

export const RequestToCallOpen: React.FC<RequestToCallOpenProp> = (props) => {
	const { phone, indicative, validateClickToCallAgentOpen, setPhone, setIndicative, setContactToCallCountry } = props;
	const {
		resources,
		isDisable,
		buildDialingPhoneCodes,
		popupMenuRef,
		maxLengthContact,
		onPressSelectCountry,
		onChangeValueIndicative,
		onClearValue,
		goTo,
	} = useRequestToCallOpenHelper({
		indicative,
		setPhone,
		setIndicative,
		setContactToCallCountry,
	});

	return (
		<Box
			styles={{
				minHeight: '90vh',
				alignItems: 'center',
				justifyContent: 'center',
			}}
		>
			<Box styles={{ flexDirection: 'column', alignItems: 'center' }}>
				<Box styles={{ flexDirection: 'column', alignItems: 'center' }}>
					<Typography appearance="headline-200-02">{resources.title}</Typography>
					<Typography appearance="headline-200-02">{resources.subtitle}</Typography>
				</Box>
				<Spacer vertical={rem(48)} />
				<Box>
					<div style={{ width: rem(110) }}>
						<InputSelect
							ref={popupMenuRef}
							mode="default"
							inputField={{
								label: resources.inputCounty,
							}}
							onPress={onPressSelectCountry}
							popupMenu={{
								popupMenuHeight: { maxHeight: rem(150) },
								hideOnClick: true,
								items: buildDialingPhoneCodes,
								zIndex: 10,
							}}
						/>
					</div>
					<Spacer horizontal={rem(8)} />
					<div style={{ width: rem(297) }}>
						<InputField
							mode="number"
							value={phone}
							inputProps={{
								maxLength: maxLengthContact,
							}}
							debounce={0}
							label={resources.inputLabel}
							onClearButtonPress={onClearValue}
							onChangeValue={onChangeValueIndicative}
						/>
					</div>
				</Box>
				<Spacer vertical={rem(56)} />
				<Box
					styles={{
						flexDirection: 'column',
						alignItems: 'center',
					}}
				>
					<Box>
						<Button disabled={isDisable} onPress={validateClickToCallAgentOpen}>
							{resources.buttonCall}
						</Button>
					</Box>
					<Spacer vertical={rem(56)} />
					<Box>
						<Button appearance="outline" onPress={goTo}>
							{resources.linkBack}
						</Button>
					</Box>
				</Box>
			</Box>
		</Box>
	);
};
